import { useCallback } from "react";
import { ErrorResponse } from "@core/types/errorResponse";
import { useErrorModalStore } from "@infrastructure/api/store/errorModalStore";


export function useApiError() {
  const { showValidation, showSystem } = useErrorModalStore();

  return useCallback((error: ErrorResponse) => {
    const status = error?.statusCode ?? 0;
    const isClientError = status >= 400 && status < 500;

    if (error?.errors && Object.keys(error.errors).length > 0) {
      const messages = Object.entries(error.errors).flatMap(([field, msgs]) =>
        msgs.map((msg) => `${field}: ${msg}`)
      );
      showValidation(messages);
    } else if (isClientError && error?.detail) {
      // Business-rule / client errors are surfaced as a friendly "Attention
      // Required" message rather than the red system-error modal.
      showValidation([error.detail]);
    } else if (error?.detail) {
      showSystem(error.detail);
    } else {
      showSystem();
    }

    if (process.env.NODE_ENV === 'development' && error?.trace?.length) {
      console.error('Trace:', error.trace);
    }
  }, [showSystem, showValidation]);
}
